// Fichier : pages/Admin/LocationsPage.js

import React from 'react';
import { useNavigate } from 'react-router-dom';
import './AdminPage.css'; // Pour styliser les boutons si besoin

const LocationsPage = () => {
  const navigate = useNavigate();

  return (
    <div className="admin-page">
      <h2>Gestion des locations</h2>
      <div className="admin-buttons">
        <button onClick={() => navigate('/admin/ajouter')}>Ajouter une location</button>
        <button onClick={() => navigate('/admin/modifier')}>Modifier une location</button>
        <button onClick={() => navigate('/admin/supprimer')}>Supprimer une location</button>
      </div>
    </div>
  );
};

export default LocationsPage;